module.exports = __webpack_public_path__ + "media/flags/cf-b76072bd.svg";